import { IPaging, IQueryParameters } from 'common/models';
import { removeFirstEmptyBracket as transformParams } from 'helper/strings';
import { ILogDetails } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

interface IProps extends IPaging, IQueryParameters {}

export const getCalculationLogs = (
  reservationId: string,
  { params, pageNo = 1, pageSize = 100 }: Partial<IProps> = {},
): Promise<ILogDetails[]> =>
  API.get(`api/accommodation/calculations/${reservationId}/logs`, {
    params: { pageSize, pageNo, ...params },
    paramsSerializer: parameters => transformParams(parameters),
  }).then(response => response?.data);
